import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  tone?: "light" | "dark";
}

export default function Breadcrumb({ items, tone = "light" }: BreadcrumbProps) {
  const base = tone === "dark" ? "text-background-300/80" : "text-foreground-500";
  const active = tone === "dark" ? "text-background-50" : "text-foreground-900";
  const linkHover = tone === "dark" ? "hover:text-accent-300" : "hover:text-primary-600";

  return (
    <nav aria-label="面包屑导航" className={`text-sm ${base}`}>
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link to={item.to} className={`transition-colors ${linkHover}`}>
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? active : ""} aria-current={isLast ? "page" : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-base opacity-60"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}